import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

type IMetricsSectionComponentProps = HTMLAttributes<HTMLDivElement> & {
  data?: {
    name?: string;
    number?: string;
  }[];
  numberClasses?: string;
};

const MetricsSectionComponent: FC<IMetricsSectionComponentProps> = ({
  data,
  numberClasses,
  className,
  ...other
}) => {
  return (
    <>
      {data && data.length > 0 && (
        <div
          className={clsx(
            "container flex flex-wrap items-center justify-evenly gap-5 gap-x-12 gap-y-7 py-5 md:gap-x-16 lg:gap-x-20 lg:gap-y-12 lg:py-8 xl:gap-x-40 xl:gap-y-20 xl:py-[50px]",
            data.length > 4 && "xl:justify-between",
            data.length === 2 && "!gap-x-0",
            className,
          )}
          {...other}
        >
          {data.map((service) => (
            <div className="grow text-center" key={service.name}>
              {service.number && (
                <span
                  className={clsx(
                    "bg-primary-gradient bg-clip-text text-h5 font-semibold text-transparent lg:text-h3 xl:text-h2",
                    numberClasses,
                  )}
                >
                  {service.number}
                </span>
              )}

              {service.name && (
                <p className="text-center text-base font-normal text-black-900">
                  {service.name}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MetricsSectionComponent;
